import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import FooterNavigationAutoSearch from "webapp/components/FooterNavigatorAutoSearch/FooterNavigatorAutoSearch";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./ATTMemberInformationForm.scss";
import { devLog } from "utils/devLog";
import { AutoSearchForm } from "webapp/components/AutoSearchForm";

const policyMap = new Map();
export default function ATTMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [email] = useState(props.currState.MemberLookup.email);
  const [phoneNumber] = useState(props.currState.MemberLookup.phoneNumber);
  const [postalCode] = useState(props.currState.MemberLookup.postalCode);
  const [firstName, setFirstName] = useState(props.context.state.FirstName);
  const [lastName, setLastName] = useState(props.context.state.LastName);
  const [firstNameInput, setFirstNameInput] = useState(props.currState.MemberLookup.firstName);
  const [lastNameInput, setLastNameInput] = useState(props.currState.MemberLookup.lastName);
  const [partnerCode, setPartnerCode] = useState(props.context.state.localGroup);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState(undefined);
  const [selectedContact, setSelectedContact] = useState(null);

  const [autoSearchRequired, setAutoSearchRequired] = useState(props.currState?.autoSearchRequired);
  const [contactName, setContactName] = useState(props.currState?.contactName ? props.currState?.contactName : "");
  const [skipMemberSearchLimit, setSkipMemberSearchLimit] = useState(props.currState?.skipMemberSearchLimit);

  // const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [displaySelectionComponent, setDisplaySelectionComponent] = useState(false);

  useEffect(() => {
    // devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
      setDisplaySelectionComponent(success);
    }
  };

  const onNextClick = () => {
    if (typeof props.onNextClick === "function") {
      props.onNextClick();
    }
  };

  const onMemberInfo = (memberInfo, contactInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contactInfo);
    }
  };

  //select Contact function, set selectContact to contactInfo => input
  //
  const onSelect = (sc) => {
    // devLog("selected contact: ", sc);
    setSelectedContact(sc);
    onMemberInfo(memberInfo, sc);
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        accountRef: props.currState.accountRef,
        contactRef: props.currState.contactRef,
        postalCode: postalCode,
        phoneNumber: phoneNumber,
        firstName: firstNameInput,
        lastName: lastNameInput,
        email: email,
        partnerCode: partnerCode,
        searchType: searchType,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (
          typeof json.data.memberInfo === "object" &&
          typeof json.data.memberInfo.contacts === "object" &&
          searchType === "AUTO_SEARCH"
        ) {
          if (!json.data.error) {
            setContacts(json.data.memberInfo.contacts);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onMemberInfo(json.data.memberInfo, json.data.memberInfo.contacts[0]);
            onLoad(true);
          } else {
            setContacts(undefined);
            setMemberInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.memberInfo === "object" && typeof json.data.memberInfo.contacts === "object") {
          if (!json.data.error) {
            setContacts(json.data.memberInfo.contacts);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts(undefined);
            setMemberInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts(undefined);
          setMemberInfo(undefined);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts(undefined);
          setMemberInfo(undefined);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setContacts(undefined);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      {/* Auto Search */}
      {memberInfo && !error && displaySelectionComponent && autoSearchRequired && skipMemberSearchLimit === 0 ? (
        <>
          <AutoSearchForm currState={props.currState} />
          <div className="errorSection">
            <b className="error">{error}</b>
            <div>
              <FooterNavigationAutoSearch onNextClick={onNextClick} onUserBack={onUserBack} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="formContainer">
            {memberInfo && !error && displaySelectionComponent ? (
              <div className="policyData">
                <div className="policyHeader">
                  <h4>{t("description.ContractInformationHeader2")}</h4>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("description.Name")}:</b> {memberInfo.name}
                  </div>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("description.ConfirmCustomerPhoneNumber")}:</b> {memberInfo.phone}
                  </div>
                  <hr />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          {contacts && !error & displaySelectionComponent && (
            <div className="policyData">
              <div className="policyHeader driverContainer">
                <h4 className="driver-header">{t("description.ContactInformationHeader")}</h4>
                <hr />
                <>
                  {contacts.map((contact, index) => {
                    return (
                      <div
                        key={index}
                        value={contact}
                        className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                        onClick={(e) => {
                          onSelect(contact);
                        }}
                      >
                        <div className="contact-list driver-list">
                          <input
                            className="vehicleSelector"
                            type="radio"
                            name="policy-vehicle"
                            checked={selectedContact === contact ? "selected" : ""}
                          />
                          <div value={contact} className="vehicle-list-item-col-1">
                            <h6 value={contact} className="name-h5">
                              {contact.firstName} {contact.lastName}
                            </h6>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              </div>
            </div>
          )}
        </>
      )}

      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
